import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { CompanyEditComponent } from '../company-edit/company-edit.component';
import { ConstantsModule } from '../constants/constants.module';
import { FolderEditRightsComponent } from '../folder-edit-rights/folder-edit-rights.component';
import { ConnectedPage } from '../root_classes/connected-page';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { UserGenerateNewPasswordComponent } from '../user-generate-new-password/user-generate-new-password.component';

@Component({
  selector: 'app-folder-detail-admin',
  templateUrl: './folder-detail-admin.component.html',
  styleUrls: ['./folder-detail-admin.component.scss']
})
export class FolderDetailAdminComponent extends ConnectedPage implements OnInit {

	private _folderId: string = "";
	public folderName: string = "";

	public userStateChoice: any[] = [];
	public companyStateChoice: any[] = [];
	public roleChoice: any[] = [];

  // Gestion de la liste des utilisateurs.
	public columnsUser: any[] = [];
	public datasUser: any[] = [];
	public firstUser: number = 0;
	public rowsUser: number = 10;


  // Gestion de la liste des sociétés.
	public columnsCompany: any[] = [];
	public datasCompany: any[] = [];
	public firstCompany: number = 0;
	public rowsCompany: number = 10;

  constructor(private activatedRoute: ActivatedRoute, constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService); 

   		this.roleChoice = [
			{label: "Utilisateur", value:"U"},
			{label: "Ingénieur", value:"I"},
			{label: "Administrateur", value:"A"}
		];

		// Creating filter list.
		this.userStateChoice = [
			{label: "Actif", value:'A'},
			{label: "Désactivé", value:'D'},
			{label: "Société désactivée", value:'SD'},
		];

    // Creating filter list.
		this.companyStateChoice = [
			{label: "Active", value:'true'},
			{label: "Désactivée", value:'false'}
		];
  }

  ngOnInit(): void {
		this._folderId = this.activatedRoute.snapshot.params.id;

    // Loading folder details.
		this.put("/api/folder-detail-admin", { id: this._folderId },
      (data) => {
        // Storing folder details.
        if (data.DATA == "OK") {
          this.folderName = data.FOLDERNAME;
          this.datasUser = data.USERSLIST;
          this.datasCompany = data.COMPANIESLIST;
        } else {
          this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
        }
      },
      (err) => {
        this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
      }
    );

    // Init users list.
		this.firstUser = 0;
		this.columnsUser = [
			{field:"username", header:"Identifiant", sort:"username"},
			{field:"role", header:"Rôle", sort:"role"},
			{field:"name", header:"Nom", sort:"name"},
			{field:"firstname", header:"Prénom", sort:"firstname"},
			{field:"active", header:"Etat", sort:"active"},
      		{field:"companyname", header: "Société", sort: "company_name"}
		];

    // Init users list.
		this.firstCompany = 0;
		this.columnsCompany = [
			{field:"name", header:"Nom", sort:"name"},
			{field:"active", header:"Etat", sort:"active"},
		];
  }


  // =================
	// Gestion des users.
	// =================
	public prevUser(): void {
		this.firstUser = this.firstUser - this.rowsUser;
	}

	public resetUser(): void {
		this.firstUser = 0;
	}

	public nextUser(): void {
		this.firstUser = this.firstUser + this.rowsUser;
	}

	public hasUser(): boolean {
		if (this.datasUser === []) return false;
		return this.datasUser.length > 0;
	}

	public isFirstPageUser(): boolean {
		return this.datasUser ? this.firstUser === 0 : true;
	}

	public isLastPageUser(): boolean {
		return this.datasUser ? (this.datasUser.length - this.firstUser) < this.rowsUser : true;
	}

	public doEditUser(userId: string, userName:string, companyName: string, companyId: string, global_active: string): void {
		this.runModalDialogWithParameters(UserEditComponent, {id:userId, username:userName, companyName: companyName},
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Un utilisateur porte déjà le nom demandé. Opération annulée.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver l'utilisateur à éditer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason:any) => {
				// Test if click outside or press space bar the dialog.
				if (reason != 1 && reason != 0) {
					for(var userIndex in this.datasUser) {
						var user = this.datasUser[userIndex];
						if (user._id == reason.id) {
							user.name = reason.name.trim().toUpperCase();
							user.firstname = reason.firstname.charAt(0).toUpperCase() + reason.firstname.trim().slice(1);
							user.role = reason.role;
							user.company_id = reason.company;
							user.company_name = reason.company_name;
							user.company_active = reason.company_active;
							user.global_active = reason.global_active;
							break;
						}
					}

					// Updating the sorting.
					this.filterDataUser();
					
					// Informations.
					this.alertLine.alertSuccessMessage = "Utilisateur modifié.";
				}
			}
		);
	}

	public doActivateUser(userId: string): void {
		// Sending activation to the server.
		var newData = {
			"userid": userId
		};
		this.put("/api/user-activate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur activé.";
				
					// Replacing the state on the list.
					for(var userIndex in this.datasUser) {
						var user = this.datasUser[userIndex];
						if (user._id == userId) {
							user.active = true;
							user.global_active = response.GLOBAL_ACTIVE;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataUser();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer l'utilisateur.";
			}
		);
	}

	public doDeactivateUser(userId: string): void {
		var newData = {
			"userid": userId
		};
		this.put("/api/user-deactivate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
				} else {
					this.alertLine.alertSuccessMessage = "Utilisateur désactivé.";

					// Replacing the state on the list.
					for(var userIndex in this.datasUser) {
						var user = this.datasUser[userIndex];
						if (user._id == userId) {
							user.active = false;
							user.global_active = response.GLOBAL_ACTIVE;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataUser();
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de désactiver l'utilisateur.";
			}
		);
	}

	public doGenerateNewUserPassword(userId: string, userName: string): void {
		this.runModalDialogWithParameters(UserGenerateNewPasswordComponent, {id: userId, username:userName},
			(result:any) => {
				if (result == "FERMETURE") return;
				this.alertLine.alertDangerMessage = "Impossible de réinitialiser le mot de passe. Contactez votre administrateur.";
			},
			(reason:any) => {
				if (reason != 1 && reason != 0) {
					this.alertLine.alertSuccessMessage = "Mot de passe réinitialisé.";
				}
			}
		);
	}

	public doChangeUserRights(): void {
		var newParam = {
			id: this._folderId,
			name: this.folderName,
			usersList: this.datasUser.map(user => user = {_id: user._id, username: user.username})
		};

		this.runModalDialogWithParameters(FolderEditRightsComponent, newParam,
			(result:any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter l'utilisateur: L'utilisateur existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
					break;
				}
			},
			(reason:any) => {
				// Test if click outside or press space bar.
				if (reason != 1 && reason != 0) {
					// Update.
					this.datasUser = [ ...reason.usersList];
					this.filterDataUser();
					
					// Info.
					this.alertLine.alertSuccessMessage = "Utilisateur ajouté.";
				}
			}
		);
	}

	public filterDataUser(): void {
		// Force filtering after modifying data.
		this.datasUser = [ ...this.datasUser];
	}


  // =================
	// Gestion des sociétés.
	// =================
	public prevCompany(): void {
		this.firstCompany = this.firstCompany - this.rowsCompany;
	}

	public resetCompany(): void {
		this.firstCompany = 0;
	}

	public nextCompany(): void {
		this.firstCompany = this.firstCompany + this.rowsCompany;
	}

	public hasCompany(): boolean {
		if (this.datasCompany === []) return false;
		return this.datasCompany.length > 0;
	}

	public isFirstPageCompany(): boolean {
		return this.datasCompany ? this.firstCompany === 0 : true;
	}

	public isLastPageCompany(): boolean {
		return this.datasCompany ? (this.datasCompany.length - this.firstCompany) < this.rowsCompany : true;
	}

  /* Actions */
	public doActivateCompany(companyId: string): void {
		// Sending activation to the server.
		var newData = {
			"companyid": companyId
		};
		this.put("/api/company-activate", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible d'activer la société.";
				} else {
					this.alertLine.alertSuccessMessage = "Société activée.";
					
					// Replacing the state on the list.
					for(var companyIndex in this.datasCompany) {
						var company = this.datasCompany[companyIndex];
						if (company._id == companyId) {
							company.active = true;
							break;
						}
					}

         			 // Filtering again datas.
					this.filterDataCompany;
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible d'activer la société.";
			}
		);
	}

	public doDeactivateCompany(companyId: string): void {
		// Sending deactivation to the server.
		var newData = {
			"companyid": companyId
		};
		this.put("/api/company-deactivate", newData,
			(response: any) => {
				if (response.DATA == "ERR") {
					this.alertLine.alertDangerMessage = "Impossible de désactiver la société.";
				} else {
					this.alertLine.alertSuccessMessage = "Société désactivée.";
					// Replacing the state on the list.
					for(var companyIndex in this.datasCompany) {
						var company = this.datasCompany[companyIndex];
						if (company._id == companyId) {
							company.active = false;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataCompany;
				}
			},
			(err: any) => {
				this.alertLine.alertDangerMessage = "Impossible de désactiver la société.";
			}
		);
	}

	public doRenameCompany(companyName: string, companyId: string): void {
		this.runModalDialogWithParameters(CompanyEditComponent, {name: companyName, id: companyId},
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Une société porte déjà le nom demandé. Opération annulée.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Impossible de trouver la société à renommer. Merci de recommencer l'opération.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur d'accès à la base de données. Contactez votre administrateur.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de la mise à jour de la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {

					for(var companyIndex in this.datasCompany) {
						var company = this.datasCompany[companyIndex];
						if (company._id == reason.id) {
							company.name = reason.name;
							break;
						}
					}

					// Filtering again datas.
					this.filterDataCompany;

					// Message informatif.
					this.alertLine.alertSuccessMessage = "Société modifiée.";
				}
			}
		);
	}

	public doChangeCompanyRights(): void {
		var newParam = {
			id: this._folderId,
      		name: this.folderName,
			companiesList: this.datasCompany.map(company => company = {_id: company._id, name: company.name}),
		};

		this.runModalDialogWithParameters(FolderEditRightsComponent, newParam,
			(result: any) => {
				if (result == "FERMETURE") return;

				switch (result) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits d'édition.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Erreur de base de données. Contactez votre administrateur.";
						break;
					case "ENTITY ALREADY EXISTS":
						this.alertLine.alertDangerMessage = "Impossible d'ajouter la société: La société existe déjà.";
						break;
					case "CANNOT CREATE ENTITY":
						this.alertLine.alertDangerMessage = "Erreur de création de la base de données. Contactez votre administrateur.";
						break;
         			default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason: any) => {
				// Test if click outside the dialog.
				if (reason != 1 && reason != 0) {
					// Updating for sorting.
					this.datasCompany = [ ...reason.companiesList ];
					this.filterDataCompany();
					
					// Message informatif.
					this.alertLine.alertSuccessMessage = "Société ajoutée.";
				}
			}
		);
	}
  public filterDataCompany(): void {
		// Force filtering after modifying data.
		this.datasCompany = [ ...this.datasCompany];
	}



  // Fonctions utilitaires.
	public filterColumns(event: Event): string {
		return (<HTMLInputElement> event.target).value;
	}
}
